<generic-search-results [showHeader]="false" [showCounter]="false" [title]="''" [records]="displayObjects"
    [displayedColumns]="displayColumns" [selectableRecords]="false" [allowLocalFilter]="false"></generic-search-results>